import { render, staticRenderFns } from "./Aprilfools.vue?vue&type=template&id=59c8e0e8&"
import script from "./Aprilfools.vue?vue&type=script&lang=js&"
export * from "./Aprilfools.vue?vue&type=script&lang=js&"
import style0 from "./Aprilfools.vue?vue&type=style&index=0&id=59c8e0e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports